import { CheckListDetailsTableRowInterface } from '@modals/check-list-details/interfaces/check-list-details-table-row.interface';
import { CHECK_LIST_DETAILS_TABLE_COLUMN } from '@modals/check-list-details/properties/check-list-details-modal.properties';

/**
 * Returns the comparable value MatTableDataSource uses for a sort header.
 *
 * @param row - checklist table row
 * @param property - active sort header id
 */
export function getCheckListDetailsTableSortValue(row: CheckListDetailsTableRowInterface, property: string): string | number {
  if (property === CHECK_LIST_DETAILS_TABLE_COLUMN.ITEM) {
    return row.itemName.toLowerCase();
  }

  if (property === CHECK_LIST_DETAILS_TABLE_COLUMN.LAST_UPDATED_BY) {
    return (row.lastUpdatedByName ?? '').toLowerCase();
  }

  if (property === CHECK_LIST_DETAILS_TABLE_COLUMN.LAST_UPDATED_ON) {
    if (!row.lastUpdatedOn) {
      return 0;
    }

    const timestamp: number = new Date(row.lastUpdatedOn).getTime();

    return Number.isNaN(timestamp) ? 0 : timestamp;
  }

  return '';
}
